export const GAME_CONFIG = {
    width: 640,
    height: 400,
    backgroundColor: '#000000'
};
